import _ from "lodash";

export class BaseClass {
  merge(req) {
    _.merge(this, req);
  }
  overwrite(req) {
    if (req instanceof Object) {
      let keys = Object.keys(this) || [];
      for (let k in req) {
        if (keys.includes(k)) {
          this[k] = req[k];
        }
      }
    }
    console.log("this", this);
  }
  pick(req) {
    const fields = _.pick(req, Object.keys(this));
    _.merge(this, fields);
  }
}

export class BaseReq extends BaseClass {}

export class BaseResp extends BaseClass {}

/**
 * 河姆渡接口响应结构
 */
export class ResponseResp<T> {
  respCode: string = "";
  respDesc: string = "";
  data: T;
  reconnection: number = 0;
}

/**
 * 分页接口入参
 */
export class PaginationReq extends BaseReq {
  current: number = 1;
  size: number = 20;
  sortBy: string = "create_time";
  sortOrder: string = "desc";
  editStart: string = "";
  editEnd: string = "";
}

/**
 * 分页接口出参
 */
export class PaginationResp<T> {
  filterTotalAmount: any;
  current: number = 0;
  size: number = 0;
  total: number = 0;
  records: T[] = [];
  name?: string = "";
  remark: any;
}

/**
 * 河姆渡更新人信息
 */
export class UpdaterResp {
  createBy: string = "";
  createName: string = "";
  createTime: string = "";
  deleteBy: string = "";
  deleteName: string = "";
  deleteTime: string = "";
  modifiedBy: string = "";
  modifiedName: string = "";
  lastModifiedTime: string = "";
  mark: number = 0;
}

/**
 * 导出入参
 */
export class ExportReq extends BaseReq {
  ids: string[] | number[] = [];
}

/**
 * 导出出参
 */
export class ExportResp extends BaseResp {
  url: string;
}

export class detailResp extends BaseResp {
  id: string = "";
  contractId: string = "";
}
/**
 * Tab 枚举
 */
export enum ContractTabEnum {
  BASIC_TAB = "BASIC_TAB", // 基本信息
  QUANTITY_TAB = "QUANTITY_TAB", // 工程量清单
  MATERIAL_TAB = "MATERIAL_TAB", // 材料清单
  ATTACHMENT_TAB = "ATTACHMENT_TAB", // 附件
  FLOW_TAB = "FLOW_TAB", // 流程
}

/**
 * 审批状态枚举
 */
export enum FlowStatusEnum {
  DTJ = "dtj", // 待提交
  SPZ = "spz", // 审批中
  SPTG = "sptg", // 审批通过
  SPBTG = "spbtg", // 审批不通过
}

export class Records<T> {
  records: T[];
}
export * from "@/components/tree-action/index";

/**
 * 项目状态
 */
export enum ProjectStatusEnum {
  DLX = "dlx", // 待立项
  DTB = "dtb", // 待投标
  TBZ = "tbz", // 投标中
  YLB = "ylb", // 已落标
  YZB = "yzb", // 已中标
  DSG = "dsg", // 待施工
  SGZ = "sgz", // 施工中
}

/**
 * 合同状态
 */
export enum ContractStatusEnum {
  WSX = "wsx", // 未生效
  SHZ = "shz", // 审核中；也叫变更中
  LYZ = "lyz", // 履约中
  YZF = "yzf", // 已作废
  LYWB = "lywb", // 履约完毕
  DSP = "dsp", // 待审批
  DQY = "dqy", // 待签约
  DLY = "dly", // 待履约
  YWC = "ywc", // 已完成
  YZZ = "yzz", // 已终止
  BGZ = "bgz", // 已终止
}
enum UploadStatus {
  READY = "READY",
  UPLOADING = "UPLOADING",
  SUCCESS = "SUCCESS",
  FAIL = "FAIL",
}
export class FileRecord extends BaseReq {
  uid: string = "";
  name: string = "";
  url: string = "";
  size: number = 0;
  suffix: string = "";
  status: UploadStatus = UploadStatus.READY;
}
